import '../../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import '../../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../../node_modules/lit-html/directives/unsafe-html.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { ButtonStyleTypes, ButtonTypes, ButtonSizes } from '../../../atoms/buttons/enums.js';
import { renderInteractiveElement } from '../../../atoms/generic-elements/interactive-element/index.js';
import { isRTL } from '../../../utilities/dom-helpers/index.js';
import { formSubmit, setActiveStep, setSelectedOption } from '../utils/index.js';

// CPD-OFF
const renderCheckbox = () => x `<div class="checkbox-container"><div class="checkbox"></div></div>`;
/* eslint-disable lit-a11y/click-events-have-key-events */
const renderOpts = (stepsArr, optonsArr, step, ctx) => optonsArr.map((opt, idx) => {
    var _a;
    return x `<label class="option-container" for="${opt.fullName}"><input class="option" type="${opt.isMultipleChoice ? 'checkbox' : 'radio'}" name="${opt.isMultipleChoice ? opt.fullName : step.type}" id="${opt.fullName}"><div class="card ${opt.isMultipleChoice ? 'checkbox' : ''}" @click="${(e) => setSelectedOption(stepsArr, ctx, idx, e)}"><img class="card__image" src="${ctx.devEnvironment
        ? 'https://picsum.photos/200'
        : (_a = opt.imageUrl) !== null && _a !== void 0 ? _a : ''}" alt=""> <span class="card__title">${o(opt.fullName)}</span> ${opt.isMultipleChoice ? renderCheckbox() : null}</div></label>`;
});
/* eslint-enable lit-a11y/click-events-have-key-events */
const generateCountString = (idx, length, preposition) => `${preposition
    .replace('[currentstep]', (idx + 1).toString())
    .replace('[stepcount]', length.toString())}`;
const renderSteps = (stepsArr, ctx) => stepsArr.map((step, idx) => {
    var _a, _b;
    const isDisabled = Boolean(idx && !((_a = stepsArr[idx - 1]) === null || _a === void 0 ? void 0 : _a.answered));
    const multipleSelected = step.selectedOptions && step.selectedOptions.length > 0
        ? `${step.selectedOptions.length} selected`
        : null;
    const details = !step.isMultipleChoice
        ? (_b = step.selectedOptions) === null || _b === void 0 ? void 0 : _b.toString()
        : multipleSelected;
    return x `<ops-step title="${step.type}" index="${idx}" elementDetails="${l(details === null ? undefined : details)}" ?isDisabled="${isDisabled}" ?isExpanded="${step.active}" ?rtl="${isRTL() || ctx.rtl}" @click="${(e) => setActiveStep(ctx.steps, ctx, idx, e)}"><div slot="accordion-content"><div class="option-meta"><span class="option-meta__count">${generateCountString(idx, stepsArr.length, ctx.dataCopy.stepsPage.numOfNumPreposition)}</span><p class="option-meta__step-question">${o(step.question)}</p></div><fieldset id="${step.type}"><legend class="visually-hidden">${step.question}</legend>${renderOpts(stepsArr, step.options, step, ctx)}</fieldset></div></ops-step>`;
});
const renderStepsForm = (ctx) => {
    var _a;
    return x `<form class="ps-form ${(_a = ctx.utilityClasses) !== null && _a !== void 0 ? _a : ''}" @submit="${() => false}"><div class="steps">${renderSteps(ctx.steps, ctx)}</div><generic-button styleType="${ButtonStyleTypes.DARK}" type="primary-button" ?disabled="${!ctx.canGetResults}" @click="${(e) => formSubmit(e, ctx, '/api/productselectorservice/result')}">${renderInteractiveElement({
        mainClass: 'primary-button',
        isAnchor: false,
        type: ButtonTypes.BUTTON,
        text: ctx.dataCopy.stepsPage.getResultsBtnText,
        href: ctx.dataCopy.resultsPage.recommendations.contactBtn.href,
        style: ButtonStyleTypes.DARK,
        size: ButtonSizes.REGULAR,
        mobileInverted: false,
        mobileWhite: false,
        disabled: !ctx.canGetResults,
        rtl: false,
    })}</generic-button></form>`;
};
// CPD-ON

export { renderOpts, renderSteps, renderStepsForm };
